import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import isExistingSlug from 'queries/theme/get-slug-exists';
import { DEFAULT_PROJECT, DEFAULT_ROUTE } from 'utils/consts';

interface Props {
  children: React.ReactNode;
}

/**
 * Renders page depending on if the project exists or not
 * To prevent wrong URLs.
 */
const ProjectRender: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [somethingWrong, setSomethingWrong] = useState(false);
  const { data: isSlugExisting, isLoading } = useQuery(isExistingSlug(projectId || ''));

  useEffect(() => {
    // Only redirect if we're not already at the default route
    if (!isLoading && !isSlugExisting && projectId !== DEFAULT_PROJECT.toString()) {
      setSomethingWrong(true);
      navigate(DEFAULT_ROUTE, { replace: true });
    }
  }, [isLoading, isSlugExisting, projectId, navigate]);

  // It won't render anything while it is loading the first time.
  if (isLoading) {
    return null;
  }

  return <>{!somethingWrong && children}</>;
};

export default ProjectRender;
